import MerchantMember from "../../components/MerchantMember/MerchantMember";

const MerchantMemberPage = () => {
  return <MerchantMember />;
};

export default MerchantMemberPage;
